<template>
  <div class="pwd">
    <el-card class="acc">
      <div class="user">
        <el-row>
          <el-col class="userL" :span="8">
            <img src="../assets/images/user.png" alt="" />
            <div class="name">{{ user.nickName }}</div>
            <div class="beizhu">
              {{ user.department }}<br />{{ user.roleName || "-" }}
            </div>
          </el-col>
          <el-col :span="16">
            <ul>
              <li>
                <div class="key">{{ $t("perAcc.account") }}</div>
                <div class="val">{{ user.userName }}</div>
              </li>
              <li>
                <div class="key">{{ $t("perAcc.tel") }}</div>
                <div class="val">{{ user.mobile }}</div>
              </li>
              <li>
                <div class="key">{{ $t("perAcc.company") }}</div>
                <div class="val">{{ user.companyUnit }}</div>
              </li>
              <li>
                <div class="key">{{ $t("perAcc.address") }}</div>
                <div class="val">{{ user.contactAddress }}</div>
              </li>
              <li>
                <div class="key">{{ $t("perAcc.gender") }}</div>
                <div class="val">
                  <el-radio v-model="user.sex" :label="1">{{
                    $t("perAcc.man")
                  }}</el-radio>
                  <el-radio v-model="user.sex" :label="2">{{
                    $t("perAcc.woman")
                  }}</el-radio>
                </div>
              </li>
              <li>
                <div class="key">
                  <div class="but" @click="updateSex()">
                    {{ $t("perAcc.save") }}
                  </div>
                </div>
              </li>
            </ul>
            <el-row>
              <el-col class="key" :span="4" :offset="1"> </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="line"></div>

      <div class="kz">
        <div class="fl box" @click="goOrder()">
          <div class="imgBox">
            <img src="../assets/images/user.png" alt="" />
          </div>
          <div class="texts">
            <div class="dai">
              {{ $t("perAcc.approved") }}: <span class="lan">{{ order }}</span>
            </div>
            <div class="cha">{{ $t("perAcc.viewApproved") }} ></div>
          </div>
        </div>
        <div class="fr box" @click="goCar()">
          <div class="imgBox">
            <img src="../assets/images/user.png" alt="" />
          </div>
          <div class="texts">
            <div class="dai">
              {{ $t("perAcc.myShopCart") }}: <span class="lan">{{ cart }}</span>
            </div>
            <div class="cha">{{ $t("perAcc.viewmyShopCart") }} ></div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import Store from "../store";
export default {
  data() {
    return {
      store: Store.state,
      radio: "1",
      user: {
        nickName: "",
        department: "",
        roleName: "",
        userName: "",
        mobile: "",
        companyUnit: "",
        contactAddress: "",
        sex: "",
      },
      cart: 0,
      order: 0,
    };
  },
  mounted() {
    // document.addEventListener("keydown", function(e) {
    //   if (e.key === "F12" || e.keyCode === 123) {
    //     e.preventDefault();
    //   }
    // });
    // document.addEventListener("contextmenu", function(e) {
    //   e.preventDefault();
    // });


    Store.setPath("1");
    this.init();
  },
  methods: {
    goOrder() {
      window.sessionStorage.setItem("daishengpi", "1");
      this.$router.push("/personal/order");
    },
    goCar() {
      this.$router.push("/personal/car");
    },
    async init() {
      let { data: res } = await this.$http.get("/c/user/getInfo");
      if (res.code != 200) {
        return;
      }
      this.user = res.data;
      let { data: res2 } = await this.$http.get("/c/user/getCount");
      if (res2.code != 200) {
        return;
      }
      this.cart = res2.data.cart;
      this.order = res2.data.order;
    },
    // 修改性别 性别 false.男 true.女
    async updateSex() {
      let { data: res } = await this.$http.post("/c/user/updateSex", {
        sex: this.user.sex,
      });
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.$message.success("修改成功");
    },
  },
};

</script>
<style lang="less" scoped>
.acc {
  // width: 60rem;
  height: 46.875rem;
  padding: 1.875rem;
  box-sizing: border-box;
  .user {
    .userL {
      text-align: center;
      img {
        width: 7.5rem;
        height: 7.5rem;
      }
      .name {
        margin: 1.25rem 0;
      }
    }
    ul {
      li {
        line-height: 3.75rem;
        height: 3.75rem;
        .key {
          text-align: justify;
          width: 6.25rem;
          margin-right: 3.125rem;
          display: inline-block;
        }
        .val {
          display: inline-block;
        }
      }
    }
  }
  .line {
    border-bottom: 0.0313rem solid #ccc;
    margin: 5rem 0 1.25rem;
  }
  .but {
    height: 2.75rem;
    line-height: 2.75rem;
  }
  .kz {
    .box {
      width: 25rem;
      height: 8.75rem;
      background-color: #eee;
      border-radius: 0.9375rem;
      padding: 1.875rem;
      box-sizing: border-box;
      .imgBox {
        width: 5rem;
        height: 5rem;
        margin-right: 1.875rem;
        display: inline-block;
        img {
          width: 5rem;
          height: 5rem;
        }
      }
      .texts {
        display: inline-block;
        width: 12.5rem;
        height: 5rem;
        transform: translateY(-1.25rem);
        .dai {
          line-height: 1.875rem;
          color: #444;
        }
        .cha {
          font-size: 0.8125rem;
        }
      }
    }
  }
}
</style>
